<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="copyright"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="copyright"><span class="small">WAKING UP IN DIXIE</span>. Copyright © 2010 by Haywood Smith. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="copyright"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Smith, Haywood.</p>
<p class="copyrighta">  Waking up in Dixie / Haywood Smith. — 1st ed.</p>
<p class="copyrighta">      p. cm.</p>
<p class="copyrighta">  ISBN 978-0-312-60976-4</p>
<p class="copyrighta">1. Married people—Fiction. 2. Bankers—Fiction. 3. Small cities—Fiction. 4. Georgia—Fiction. 5. Midlife crisis—Fiction. 6. Domestic fiction. I. Title.</p>
<p class="copyrighta">  PS3569.M53728W35 2010</p>
<p class="copyrighta">  813'.54—dc22</p>
<p class="copyrightr">2010021669</p>
<p class="para"> </p>
<p class="copyright">First Edition: September 2010</p>
<p class="para"> </p>
<p class="copyright">10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?234e3da9